import { render } from "./ProjectManagerDashboard.vue?vue&type=template&id=7113de1a&scoped=true"
import script from "./ProjectManagerDashboard.vue?vue&type=script&lang=js"
export * from "./ProjectManagerDashboard.vue?vue&type=script&lang=js"

import "./ProjectManagerDashboard.vue?vue&type=style&index=0&id=7113de1a&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7113de1a"]])

export default __exports__